// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "3158a62388322b50251cfe9138310c94" + ".css";
};